'use client';

import { useFacebookPixelEvents } from '@/hooks/use-facebook-pixel-events';
import { usePathname } from '@/i18n/routing';
import { useAuth } from '@/lib/auth/use-auth';
import { useEffect } from 'react';

type TrackFacebookPixelViewContentProps = {
  courseId: number;
};

export function TrackFacebookPixelViewContent({
  courseId,
}: TrackFacebookPixelViewContentProps) {
  const { trackViewContent } = useFacebookPixelEvents();
  const { user } = useAuth();
  const pathname = usePathname();

  useEffect(() => {
    trackViewContent(
      {
        email: user?.email,
        phone: user?.phone,
      },
      {
        page_url: pathname,
        content_ids: [courseId],
        content_type: 'course',
      },
    );
  }, [trackViewContent, courseId, user, pathname]);

  return null;
}
